interface PageParams {
    pathname: string;
    generalKeys: string[];
    tabs: string[];
    theme?: string;
    sites: string[];
}

export const pageParams: PageParams = {
    pathname: 'delta-3-ultra-series-portable-power-station',
    generalKeys: ['product_ps_delta_delta_3_u', 'product_ps_delta_delta_3_u_p'],
    // pathname: 'rapid-pro-power-bank',
    // generalKeys: ['pb501-x', 'rapid_pro_012'],
    tabs: ['product', 'Spec', 'support'],
    theme: 'white',
    sites: ['jp'],
};

export const pathname = pageParams.pathname;
export const generalKeys = pageParams.generalKeys;
export const tabs = pageParams.tabs;
export const theme = pageParams.theme;
export const sites = pageParams.sites;
